import { AppButton } from 'components/form';
import { t } from 'utilities/TranslationUtils';
import AppSpacer from './AppSpacer';
import AppUseIcon from './AppUseIcon';

const AppPageHeader = ({
  title,
  subtitle = '',
  backBtn = { isVisible: false, onClick: () => {} },
  children
}: {
  title: string;
  subtitle?: string;
  backBtn?: { isVisible: boolean; onClick: () => void };
  children?: React.ReactNode;
}) => {
  return (
    <>
      <div className='position-relative w-100 m-0'>
        <div className='row'>
          <div className='col-2'>
            {backBtn.isVisible && (
              <AppButton
                variant='transparent'
                className=' font-13 font-500 text-uppercase font-oswald d-flex align-items-center'
                data-test='back-button'
                onClick={() => backBtn.onClick()}
              >
                <AppUseIcon className='mr-3' name='ChevronLeft' width='10' height='16' />
                {t('back')}
              </AppButton>
            )}
          </div>
          <div className='col-8'>
            <h1 className='text-center mb-0 font-25 text-uppercase'>
              {title}
            </h1>
          </div>
          <div className='col-2'>
          </div>
        </div>
        <div className='row'>
          <div className='col-6 d-flex align-items-center'>
            <h2 className='text-left mb-0 font-22 text-uppercase'>
              {subtitle}
            </h2>
          </div>
          <div className='col-6'>
            <div className='d-flex justify-content-end gap-2 align-items-center'>
              {children}
            </div>
          </div>
        </div>
      </div>
      <AppSpacer space='16px' />
    </>
  );
};

export default AppPageHeader;
